const ARIZONA_TIME_ZONE = "America/Phoenix";

const ARIZONA_DATE_PART_FORMATTER = new Intl.DateTimeFormat("en-US", {
  timeZone: ARIZONA_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function arizonaIsoDate(value = new Date()) {
  const date = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(date.getTime())) return "";
  const parts = Object.fromEntries(
    ARIZONA_DATE_PART_FORMATTER.formatToParts(date).map((part) => [part.type, part.value])
  );
  return `${parts.year}-${parts.month}-${parts.day}`;
}
